(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function observeCartDrawer(selector, callback, ms) {
    ms = ms === undefined ? 100 : ms;
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    new MutationObserver(function (mutations) {
      const hit = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          return node.nodeType === 1 &&
            (node.matches && node.matches(selector) ||
             node.querySelector && node.querySelector(selector));
        });
      });
      if (hit) setTimeout(callback, ms);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  function toJsonUrl(base) {
    return base.replace(/\.js$/, '') + '.js';
  }

  function cartChangeUrl() {
    var base = (typeof routes !== 'undefined' && routes.cart_change_url) || '/cart/change';
    return toJsonUrl(base);
  }

  function cartAddUrl() {
    var base = (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add';
    return toJsonUrl(base);
  }

  function cartUrl() {
    return (typeof routes !== 'undefined' && routes.cart_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) ||
      '/cart';
  }

  function cartJsUrl() {
    return toJsonUrl(cartUrl());
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  var cachedCartCurrency = null;
  var cartCurrencyFetch = null;

  function cacheCartCurrency(code) {
    if (code) cachedCartCurrency = String(code);
  }

  function fetchCartCurrency() {
    if (cachedCartCurrency) return Promise.resolve(cachedCartCurrency);
    if (cartCurrencyFetch) return cartCurrencyFetch;

    cartCurrencyFetch = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cacheCartCurrency(cart && cart.currency);
        return cachedCartCurrency || '';
      })
      .catch(function () {
        return '';
      });

    return cartCurrencyFetch;
  }

  function resolvePresentmentRate(shopCurrency, cartCurrency, liquidRate) {
    if (!shopCurrency || !cartCurrency || shopCurrency === cartCurrency) return 1;

    var liquid = parseFloat(liquidRate);
    if (liquid > 0 && liquid !== 1) return liquid;

    return 1;
  }

  // The presentment threshold is resolved server-side from the per-currency
  // table in snippets/shipping-threshold.liquid, so there is no rate to derive
  // here. Only the shop→presentment ratio from the bootstrap is used, and only
  // to scale A/B variants that override the USD baseline.

  /** Shop USD cents → cart presentment cents (bootstrap ratio, then anchor rate). */
  function getPresentmentThresholdCents(shopCents) {
    if (
      window.NorseShippingThreshold &&
      typeof window.NorseShippingThreshold.getPresentmentThresholdCents === 'function'
    ) {
      return window.NorseShippingThreshold.getPresentmentThresholdCents(shopCents);
    }

    shopCents = parseInt(shopCents, 10);
    if (!(shopCents > 0)) return 0;

    var bootstrap = readShippingBootstrap();
    var shopCurrency =
      (bootstrap && bootstrap.shopCurrency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.shop) ||
      'USD';
    var cartCurrency =
      (bootstrap && bootstrap.cartCurrency) ||
      cachedCartCurrency ||
      shopCurrency;

    if (shopCurrency === cartCurrency) return shopCents;

    if (bootstrap && bootstrap.shopCents > 0 && bootstrap.presentmentCents > 0) {
      return Math.round(shopCents * (bootstrap.presentmentCents / bootstrap.shopCents));
    }

    return shopCents;
  }

  var DOLLAR_SYMBOL_PREFIX = {
    AUD: 'A$',
    CAD: 'CA$',
    NZD: 'NZ$',
    HKD: 'HK$',
    SGD: 'S$',
    MXN: 'MX$',
  };

  function applyDollarSymbolPrefix(formatted, currency) {
    var prefix = DOLLAR_SYMBOL_PREFIX[currency];
    if (!prefix || !formatted) return formatted;
    var out = String(formatted).replace(/^[\s\u00a0\u200e\u200f\ufeff]+/, '');
    if (out.indexOf(prefix) !== -1) return out;
    if (currency === 'CAD' && out.indexOf('C$') === 0) return 'CA$' + out.slice(2);
    if (currency === 'AUD' && out.indexOf('AU$') === 0) return 'A$' + out.slice(3);
    if (out.charAt(0) === '$') return prefix + out.slice(1);
    return out.replace('$', prefix);
  }

  function applyLeiSuffix(formatted, currency) {
    if (currency !== 'RON' || !formatted) return formatted;
    var out = String(formatted)
      .replace(/^[\s\u00a0\u200e\u200f\ufeff]+/, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (/\blei\b/i.test(out) && !/^RON\b/i.test(out)) return out;
    var m = out.match(/^RON\s*(.+)$/i);
    if (m) {
      var rest = m[1].replace(/\s+RON\b/i, '').trim();
      if (/\blei\b/i.test(rest)) return rest;
      return rest + ' lei';
    }
    out = out.replace(/\s+RON\b/i, '').trim();
    if (/\blei\b/i.test(out)) return out;
    return out + ' lei';
  }

  function formatPresentmentMoney(cents, opts) {
    if (window.NorseShippingThreshold && typeof window.NorseShippingThreshold.formatMoney === 'function') {
      var currency =
        (opts && opts.cartCurrency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        '';
      return applyLeiSuffix(
        applyDollarSymbolPrefix(window.NorseShippingThreshold.formatMoney(cents, opts), currency),
        currency
      );
    }

    opts = opts || {};
    cents = Math.round(Number(cents) || 0);
    if (!(cents >= 0)) return '';

    var currency =
      (opts && opts.cartCurrency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    var hasFraction = opts.keepCents || cents % 100 !== 0;
    var out = '';
    try {
      out = new Intl.NumberFormat(currency === 'RON' ? 'ro-RO' : 'en-US', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0,
      }).format(cents / 100);
    } catch (e) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        out = window.Shopify.formatMoney(cents);
      } else {
        out = String(cents / 100);
      }
    }
    out = applyDollarSymbolPrefix(out, currency);
    out = applyLeiSuffix(out, currency);
    out = out.replace(new RegExp('\\s+' + currency + '\\b', 'i'), '');
    if (!opts.keepCents) {
      // Drop zero cents only — never a real fractional amount.
      out = out.replace(/([.,]00)(?=\s|[A-Z]{3}|$)/, '');
    }
    return applyLeiSuffix(out, currency);
  }

  function roundToDisplayCents(cents) {
    return roundToDisplayCentsLocal(cents);
  }

  function roundToDisplayCentsLocal(cents) {
    cents = Math.round(Number(cents) || 0);
    return Math.floor((cents + 50) / 100) * 100;
  }

  function applyProgressBarState(root, threshold, shippingTotal) {
    threshold = roundToDisplayCents(threshold);
    var shippingUnlocked = threshold > 0 && shippingTotal >= threshold;

    // Second milestone, present only while a free-gift promo is actually running
    // (progress-bar.liquid decides that, not this). When it is, the track spans
    // 0 → gift threshold and free shipping becomes a dot part-way along it, so
    // every figure below is measured against the gift rather than the shipping.
    var giftThreshold = parseInt(root.dataset.fgThresholdPresentment, 10) || 0;
    var giftTotal = parseInt(root.dataset.fgGiftTotal, 10) || 0;
    var hasGift = giftThreshold > threshold;
    var giftUnlocked = hasGift && giftTotal >= giftThreshold;

    var trackTotal = hasGift ? giftThreshold : threshold;
    var trackProgress = hasGift ? giftTotal : shippingTotal;
    var remaining = Math.max(0, threshold - shippingTotal);
    var pct = trackTotal > 0 ? Math.min(100, Math.floor((trackProgress * 100) / trackTotal)) : 0;
    var unlocked = hasGift ? giftUnlocked : shippingUnlocked;

    root.style.setProperty('--cart-update-progress', pct + '%');
    root.dataset.fsThresholdPresentment = String(threshold);

    var progressEl = root.querySelector('.free-shipping__progress');
    if (progressEl) progressEl.style.width = pct + '%';

    var bar = root.querySelector('.free-shipping__bar');
    if (bar) bar.classList.toggle('free-shipping__bar--complete', unlocked);

    if (hasGift) {
      // An A/B test can move the shipping threshold under us, which slides the
      // intermediate dot along a track whose length is set by the gift.
      var markerPct = Math.min(100, Math.floor((threshold * 100) / giftThreshold));
      root.style.setProperty('--cart-update-shipping-marker', markerPct + '%');

      var marker = root.querySelector('.free-shipping__marker');
      if (marker) {
        marker.style.left = markerPct + '%';
        marker.classList.toggle('free-shipping__marker--reached', shippingUnlocked);
      }
      var markerLabel = root.querySelector('.free-shipping__marker-label');
      if (markerLabel) markerLabel.style.left = markerPct + '%';
    }

    var message = root.querySelector('.free-shipping__message');
    if (message) message.classList.toggle('free-shipping__message--success', unlocked);
    if (!message) return;

    // Localized copy comes from data attributes rendered by progress-bar.liquid
    // ({{ '…' | t }}); the English literals are only a fallback for stale markup.
    //
    // Always names the NEXT thing still to be earned. With both milestones live
    // that is three states, not two: shipping, then the gift, then everything
    // unlocked — announcing free shipping to someone who passed it two lines ago
    // is what made the single-milestone copy read as broken here.
    var namesGift = hasGift && shippingUnlocked && !giftUnlocked;

    if (unlocked) {
      var unlockedMsg = hasGift
        ? (root.dataset.fgMsgUnlocked || "You've unlocked free shipping + your free gift")
        : (root.dataset.fsMsgUnlocked || "You're eligible for FREE SHIPPING");
      message.innerHTML =
        '<p class="free-shipping__text free-shipping__text--success">' +
        unlockedMsg + '</p>';
    } else {
      if (namesGift) remaining = Math.max(0, giftThreshold - giftTotal);

      var remainingTemplate = namesGift
        ? (root.dataset.fgMsgRemainingTemplate ||
            'Spend __AMOUNT__ more and get a <span>FREE GIFT</span>')
        : (root.dataset.fsMsgRemainingTemplate ||
            'Spend __AMOUNT__ more and get <span>FREE SHIPPING</span>');
      var remainingFormatted = formatPresentmentMoney(remaining, {
        cartCurrency: root.dataset.fsCartCurrency,
        cartSymbol: root.dataset.fsCartCurrencySymbol,
        shopCurrency: root.dataset.fsShopCurrency,
      });
      remainingFormatted = applyLeiSuffix(
        applyDollarSymbolPrefix(remainingFormatted, root.dataset.fsCartCurrency),
        root.dataset.fsCartCurrency
      );
      message.innerHTML =
        '<p class="free-shipping__text">' +
        remainingTemplate.replace('__AMOUNT__', function () { return remainingFormatted; }) + '</p>';
    }
  }

  function readShippingBootstrap() {
    var el = document.getElementById('norse-shipping-threshold-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Re-sync the progress bar.
   *
   * The presentment threshold rendered by snippets/progress-bar.liquid is
   * authoritative — it comes from the per-currency table that mirrors the
   * shipping zones, so there is nothing to recompute or "correct" here. This
   * only refreshes the bar against the current shipping total, and picks up
   * the bootstrap value when an A/B script overrode the USD baseline after
   * the server rendered the bar.
   */
  function syncProgressBarPresentment() {
    var bootstrap = readShippingBootstrap();

    document.querySelectorAll('.free-shipping[data-fs-threshold-presentment]').forEach(function (root) {
      // Block-driven bars decide their own copy and marker positions in Liquid,
      // and the drawer section re-renders on every cart change, so patching them
      // here could only ever overwrite fresher markup with a one-milestone view.
      if (root.dataset.fsMilestones) return;

      var shippingTotal = parseInt(root.dataset.fsShippingTotal, 10) || 0;
      var threshold = parseInt(root.dataset.fsThresholdPresentment, 10);
      var shopThreshold = parseInt(root.dataset.fsThresholdShop, 10);

      if (bootstrap && bootstrap.displayCents > 0) {
        var baselineChanged =
          shopThreshold > 0 && bootstrap.shopCents > 0 && shopThreshold !== bootstrap.shopCents;
        if (baselineChanged || !(threshold > 0)) {
          threshold = bootstrap.displayCents;
          if (bootstrap.shopCents > 0) root.dataset.fsThresholdShop = String(bootstrap.shopCents);
        }
      }

      if (!(threshold > 0)) return;
      applyProgressBarState(root, threshold, shippingTotal);
    });
  }

  function scheduleProgressBarSync() {
    fetchCartCurrency().finally(function () {
      syncProgressBarPresentment();
      window.setTimeout(syncProgressBarPresentment, 250);
      window.setTimeout(syncProgressBarPresentment, 1000);
    });
  }

  var SPINNER_SVG =
    '<svg focusable="false" class="norse-remove-spinner" viewBox="25 25 50 50" aria-hidden="true">' +
    '<circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="6"></circle>' +
    '</svg>';

  function updateCartUpdateHeaderCount(itemCount) {
    if (typeof itemCount !== 'number') return;
    var el = document.querySelector('cart-drawer.cart_update .drawer__header-cart-update-count');
    if (el) el.textContent = String(itemCount);
  }

  // Two separate things, deliberately counted apart.
  //
  // busy  = input is locked. Taken for the whole of any cart work, including a
  //         read-only reconcile, because a shopper must not be able to act on a
  //         cart that is still being verified.
  // veil  = the drawer is visibly dimmed. Only for work that actually WRITES to
  //         the cart. A pass that reads, finds nothing wrong and writes nothing
  //         had no risk to communicate, so it must not dim anything: doing so is
  //         what made a single click flash the drawer twice.
  //
  // Callers that pass { silent: true } lock input without asking for a veil, and
  // must pass it on release too.
  var cartDrawerBusyCount = 0;
  var cartDrawerVeilCount = 0;
  var cartDrawerVeilPaint = null;
  var cartDrawerVeilClear = null;

  // Painted only if a write outlasts this, and kept up briefly afterwards so a
  // sequence of line-by-line writes reads as one dim rather than a strobe.
  var CART_DRAWER_VEIL_DELAY_MS = 200;
  var CART_DRAWER_VEIL_LINGER_MS = 250;

  function setCartDrawerBusy(isBusy, opts) {
    var drawer = document.querySelector('cart-drawer.cart_update');
    if (!drawer) return;

    if (isBusy) {
      cartDrawerBusyCount += 1;
    } else {
      cartDrawerBusyCount = Math.max(0, cartDrawerBusyCount - 1);
    }
    // Immediate and unconditional: the lock must never lag the work, and it applies
    // to silent holds too. Only the visible veil below is deferred or skipped.
    drawer.classList.toggle('cart-drawer--locked', cartDrawerBusyCount > 0);
    drawer.setAttribute('aria-busy', cartDrawerBusyCount > 0 ? 'true' : 'false');

    if (opts && opts.silent) return;

    if (isBusy) {
      cartDrawerVeilCount += 1;
    } else {
      cartDrawerVeilCount = Math.max(0, cartDrawerVeilCount - 1);
    }

    if (cartDrawerVeilCount > 0) {
      clearTimeout(cartDrawerVeilClear);
      cartDrawerVeilClear = null;
      if (cartDrawerVeilPaint || drawer.classList.contains('cart-drawer--busy')) return;
      cartDrawerVeilPaint = setTimeout(function () {
        cartDrawerVeilPaint = null;
        if (cartDrawerVeilCount > 0) drawer.classList.add('cart-drawer--busy');
      }, CART_DRAWER_VEIL_DELAY_MS);
      return;
    }

    clearTimeout(cartDrawerVeilPaint);
    cartDrawerVeilPaint = null;
    if (cartDrawerVeilClear) return;
    cartDrawerVeilClear = setTimeout(function () {
      cartDrawerVeilClear = null;
      if (cartDrawerVeilCount > 0) return;
      drawer.classList.remove('cart-drawer--busy');
    }, CART_DRAWER_VEIL_LINGER_MS);
  }

  // Reads the busy counter, never the class: the class is purely visual now, and is
  // absent entirely for read-only work. Gating input on it would leave every
  // verification pass wide open.
  function isCartDrawerBusy() {
    return cartDrawerBusyCount > 0;
  }

  function setRemoveControlLoading(control, isLoading) {
    if (!control) return;

    if (isLoading) {
      if (!control.getAttribute('data-norse-orig-html')) {
        control.setAttribute('data-norse-orig-html', control.innerHTML || '');
      }
      control.setAttribute('aria-disabled', 'true');
      control.style.pointerEvents = 'none';
      control.style.opacity = '0.6';
      control.innerHTML = SPINNER_SVG;
      return;
    }

    var orig = control.getAttribute('data-norse-orig-html');
    if (orig !== null) control.innerHTML = orig;
    control.removeAttribute('data-norse-orig-html');
    control.removeAttribute('aria-disabled');
    control.style.pointerEvents = '';
    control.style.opacity = '';
  }

  function renderCartDrawerFromState(cartState) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionHtml = cartState && cartState.sections && cartState.sections['cart-drawer'];

    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !sectionHtml) {
      return false;
    }

    var isEmptyFromMarkup = null;
    if (typeof sectionHtml === 'string') {
      var parsedDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var parsedDrawer = parsedDoc.querySelector('cart-drawer');
      if (parsedDrawer) {
        isEmptyFromMarkup = parsedDrawer.classList.contains('is-empty');
      } else if (parsedDoc.querySelector('.drawer__inner-empty')) {
        isEmptyFromMarkup = true;
      } else if (parsedDoc.querySelector('.drawer__cart-items-wrapper')) {
        isEmptyFromMarkup = false;
      }
    }

    if (typeof cartState.item_count === 'number') {
      cartDrawer.classList.toggle('is-empty', cartState.item_count === 0);
      updateCartUpdateHeaderCount(cartState.item_count);
    } else if (typeof isEmptyFromMarkup === 'boolean') {
      cartDrawer.classList.toggle('is-empty', isEmptyFromMarkup);
    }

    cartDrawer.renderContents(cartState);

    if (typeof isEmptyFromMarkup === 'boolean') {
      cartDrawer.classList.toggle('is-empty', isEmptyFromMarkup);
    }

    requestAnimationFrame(function () {
      syncCartUpdatePairWith(cartState).catch(console.error);
    });

    return true;
  }

  /**
   * The drawer's REAL section id.
   *
   * This section lives in a section group, so its id is generated
   * (`sections--123__cart_drawer_aTk9UL`) and is not the file name. Asking the
   * Section Rendering API for `cart-drawer` still returns 200 — it renders the
   * file with NO placed-instance config, so `section.blocks` comes back empty and
   * the progress bar silently falls back to its blockless form. That is why a
   * second milestone kept vanishing after a cart update and returning on reload.
   *
   * The wrapper element sits OUTSIDE everything the refresh replaces, so this can
   * be read at any time. Falls back to the file name, i.e. to the old behaviour.
   */
  function cartDrawerSectionId() {
    var host = document.querySelector('cart-drawer');
    var wrapper = host && host.closest('[id^="shopify-section-"]');
    if (!wrapper) return 'cart-drawer';
    return wrapper.id.replace(/^shopify-section-/, '') || 'cart-drawer';
  }

  function refreshCartDrawer() {
    setCartDrawerBusy(true);
    return fetch(cartUrl() + '?section_id=' + encodeURIComponent(cartDrawerSectionId()))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        ['cart-drawer-items', '#CartDrawer .drawer__footer', '.cart-update-shipping-zone'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var source = doc.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });

        var headerTarget = document.querySelector('.drawer__header-cart-update');
        var headerSource = doc.querySelector('.drawer__header-cart-update');
        if (headerTarget && headerSource) headerTarget.replaceWith(headerSource.cloneNode(true));

        var socialTarget = document.querySelector('.cart-update-social-proof');
        var socialSource = doc.querySelector('.cart-update-social-proof');
        if (socialTarget && socialSource) {
          socialTarget.replaceWith(socialSource.cloneNode(true));
        } else if (socialTarget && !socialSource) {
          socialTarget.remove();
        } else if (!socialTarget && socialSource) {
          var shippingZone = document.querySelector('.cart-update-shipping-zone');
          if (shippingZone) shippingZone.insertAdjacentElement('afterend', socialSource.cloneNode(true));
        }

        var emptyTarget = document.querySelector('.drawer__inner-empty');
        var emptySource = doc.querySelector('.drawer__inner-empty');
        if (emptyTarget && emptySource) {
          emptyTarget.replaceWith(emptySource.cloneNode(true));
        } else if (emptySource && !emptyTarget) {
          var emptyAnchor =
            document.querySelector('.cart-update-social-proof') ||
            document.querySelector('.cart-update-shipping-zone') ||
            document.querySelector('.drawer__header');
          if (emptyAnchor) emptyAnchor.insertAdjacentElement('afterend', emptySource.cloneNode(true));
        } else if (!emptySource && emptyTarget) {
          emptyTarget.remove();
        }

        var freshBubble = doc.getElementById('cart-icon-bubble');
        if (freshBubble) {
          document.querySelectorAll('[id="cart-icon-bubble"]').forEach(function (b) {
            b.innerHTML = freshBubble.innerHTML;
          });
        }

        var current = document.querySelector('cart-drawer');
        var fresh   = doc.querySelector('cart-drawer');
        if (current && fresh) {
          current.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          var overlay = current.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', current.close.bind(current));
        }

        return syncCartUpdatePairWith().then(function () {
          scheduleProgressBarSync();
          if (window.NorseShippingThresholdContent && typeof window.NorseShippingThresholdContent.run === 'function') {
            window.NorseShippingThresholdContent.run();
          }
        });
      })
      .finally(function () {
        setCartDrawerBusy(false);
      });
  }

  function updateCTATotal(cartTotal) {
    if (typeof cartTotal !== 'number') return;
    var nodes = document.querySelectorAll('#CartDrawer-Checkout .cta-button__text');
    if (!nodes.length) return;
    var checkoutButton = document.getElementById('CartDrawer-Checkout');
    var root = document.querySelector('.free-shipping[data-fs-cart-currency]');
    var currency =
      (root && root.dataset.fsCartCurrency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
    var formatted = formatPresentmentMoney(cartTotal, { cartCurrency: currency });
    var labelTemplate = (checkoutButton && checkoutButton.dataset.labelTemplate) ||
      'Secure checkout - __AMOUNT__';
    // Decode entities: `t` escapes the locale string, so "&" arrives as "&amp;"
    // and would render literally once written into textContent.
    if (labelTemplate.indexOf('&') !== -1) {
      var _dec = document.createElement('textarea');
      _dec.innerHTML = labelTemplate;
      labelTemplate = _dec.value || labelTemplate;
    }
    var label = labelTemplate.replace('__AMOUNT__', function () { return formatted; });
    nodes.forEach(function (el) {
      el.textContent = label;
      if (el.dataset) el.dataset.norseMoneyCents = String(cartTotal);
    });
  }

  function addRecommendationToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var productId = button.getAttribute('data-product-id');
    if (!variantId) { console.error('[NorseCartUI] No variant ID on recommendation button'); return; }

    if (isCartDrawerBusy()) return;

    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Adding...';
    setCartDrawerBusy(true);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ id: variantId, quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data.status) throw new Error(data.description || data.message || 'Error adding to cart.');

      if (productId) {
        document.querySelectorAll('.cart-recommendation-card[data-product-id="' + productId + '"]')
          .forEach(function (card) {
            card.classList.add('hiding');
            setTimeout(function () { card.style.display = 'none'; }, 300);
          });
      }

      var done = function () { button.disabled = false; button.textContent = originalText; };
      if (renderCartDrawerFromState(data)) {
        done();
        return;
      }
      return refreshCartDrawer().catch(console.error).finally(done);
    })
    .catch(function (err) {
      console.error('[NorseCartUI] Error adding recommendation:', err);
      button.disabled = false;
      button.textContent = originalText;
      alert('Error adding to cart. Please try again.');
    })
    .finally(function () {
      setCartDrawerBusy(false);
    });
  }

  var KARR_HANDLE = 'kill-acne-redness-ritual';
  var PAIR_WITH_STORAGE_LOCK = 'norse_pair_with_locked_handles';
  var PAIR_WITH_STORAGE_ANCHOR = 'norse_pair_with_anchor_handle';
  var pairWithSyncTimer = null;
  var pairWithSyncFinalizeTimer = null;
  var pairWithLastCartData = null;

  var PAIR_WITH_TABLE = {
    'kill-acne-redness-ritual': ['acne-redness-killer', 'muscle-joint-builder', 'acne-scars-healer-preventer'],
    'acne-redness-killer': ['kill-acne-redness-ritual', '6-in-1-daily-glow-moisturize', 'muscle-joint-builder'],
    'muscle-joint-builder': ['kill-acne-redness-ritual', 'acne-redness-killer', '6-in-1-daily-glow-moisturize'],
    'the-complete-acne-killer-system-2-0': ['kill-acne-redness-ritual', 'acne-redness-killer', 'muscle-joint-builder'],
    '6-in-1-daily-glow-moisturize': ['kill-acne-redness-ritual', 'acne-redness-killer', 'muscle-joint-builder'],
    'anti-age-glow-ritual': ['kill-acne-redness-ritual', 'acne-redness-killer', 'muscle-joint-builder'],
    'acne-scars-healer-preventer': ['kill-acne-redness-ritual', 'acne-redness-killer', '6-in-1-daily-glow-moisturize'],
    'wrinkle-dark-circle-warrior': ['kill-acne-redness-ritual', 'acne-redness-killer', '6-in-1-daily-glow-moisturize'],
    'body-balm-for-acne-prone-skin-body-acne-killer': ['kill-acne-redness-ritual', 'acne-redness-killer', '6-in-1-daily-glow-moisturize'],
    'the-complete-acne-stopper-starter-pack': ['kill-acne-redness-ritual', 'acne-redness-killer', 'acne-scars-healer-preventer']
  };

  var PAIR_WITH_FALLBACK_NON_KARR = ['kill-acne-redness-ritual', 'acne-redness-killer', 'muscle-joint-builder'];
  var PAIR_WITH_FALLBACK_KARR = ['acne-redness-killer', 'muscle-joint-builder', 'anti-age-glow-ritual'];

  function computePairWithLockedHandles(anchorHandle) {
    if (!anchorHandle) return PAIR_WITH_FALLBACK_NON_KARR.slice();

    if (anchorHandle === KARR_HANDLE) {
      return (PAIR_WITH_TABLE[KARR_HANDLE] || PAIR_WITH_FALLBACK_KARR).slice(0, 3);
    }

    var row = PAIR_WITH_TABLE[anchorHandle];
    if (!row) {
      return PAIR_WITH_FALLBACK_NON_KARR.slice(0, 3);
    }

    var locked = [KARR_HANDLE];
    for (var i = 0; i < row.length && locked.length < 3; i++) {
      var handle = row[i];
      if (handle === anchorHandle) continue;
      if (locked.indexOf(handle) !== -1) continue;
      locked.push(handle);
    }
    return locked.slice(0, 3);
  }

  function readPairWithLockedHandles() {
    try {
      var raw = sessionStorage.getItem(PAIR_WITH_STORAGE_LOCK);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function writePairWithLockedHandles(handles) {
    sessionStorage.setItem(PAIR_WITH_STORAGE_LOCK, JSON.stringify(handles));
  }

  function readPairWithAnchor() {
    return sessionStorage.getItem(PAIR_WITH_STORAGE_ANCHOR);
  }

  function writePairWithAnchor(handle) {
    if (handle) sessionStorage.setItem(PAIR_WITH_STORAGE_ANCHOR, handle);
  }

  function clearPairWithSession() {
    sessionStorage.removeItem(PAIR_WITH_STORAGE_LOCK);
    sessionStorage.removeItem(PAIR_WITH_STORAGE_ANCHOR);
  }

  function getPrimaryCartAnchor(cart) {
    var presence = getCartPresenceFromDrawer();
    if (presence.handles.length) return presence.handles[0];

    if (cart && cart.items && cart.items.length) {
      for (var i = 0; i < cart.items.length; i++) {
        var handle = getCartLineHandle(cart.items[i]);
        if (handle) return handle;
      }
    }
    return null;
  }

  function isInCartPresence(handle, productId, presence) {
    var handles = presence.handles || [];
    var ids = presence.productIds || [];
    return handles.indexOf(handle) !== -1 || (productId && ids.indexOf(productId) !== -1);
  }

  function countVisibleLocked(lockedHandles, cartPresence) {
    var count = 0;
    lockedHandles.forEach(function (handle) {
      var slide = document.querySelector(
        '[data-cart-update-pair-with] [data-pair-with-slide][data-product-handle="' + handle + '"]'
      );
      if (!slide || slide.getAttribute('data-available') !== 'true') return;
      if (!isInCartPresence(handle, slide.getAttribute('data-product-id'), cartPresence)) count++;
    });
    return count;
  }

  function resolvePairWithLocked(cart) {
    var presence = mergeCartPresence(cart);
    var locked = readPairWithLockedHandles();
    var storedAnchor = readPairWithAnchor();
    var primary = getPrimaryCartAnchor(cart);

    if (!primary) {
      return { locked: locked || [], presence: presence };
    }

    var needsRelock = !locked || !locked.length;
    if (!needsRelock && storedAnchor && presence.handles.indexOf(storedAnchor) === -1) {
      needsRelock = true;
    }
    if (!needsRelock && countVisibleLocked(locked, presence) === 0) {
      needsRelock = true;
    }

    if (needsRelock) {
      locked = computePairWithLockedHandles(primary);
      writePairWithLockedHandles(locked);
      writePairWithAnchor(primary);
    }

    return { locked: locked || [], presence: presence };
  }

  function runScheduledPairWithSync(useCachedCart) {
    syncCartUpdatePairWith(useCachedCart ? pairWithLastCartData : null).catch(console.error);
  }

  function schedulePairWithSync(cartOptional, delay) {
    if (cartOptional) pairWithLastCartData = cartOptional;

    clearTimeout(pairWithSyncTimer);
    pairWithSyncTimer = setTimeout(function () {
      runScheduledPairWithSync(true);
    }, delay);

    clearTimeout(pairWithSyncFinalizeTimer);
    pairWithSyncFinalizeTimer = setTimeout(function () {
      runScheduledPairWithSync(false);
    }, 650);
  }

  function getCartLineHandle(item) {
    if (!item) return null;
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    if (item.url) {
      var match = item.url.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }
    return null;
  }

  function getCartPresenceFromDrawer() {
    var handles = [];
    var productIds = [];
    document.querySelectorAll('cart-drawer.cart_update tr.cart-item[data-product-handle]').forEach(function (row) {
      var handle = row.getAttribute('data-product-handle');
      var productId = row.getAttribute('data-product-id');
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
      if (productId && productIds.indexOf(productId) === -1) productIds.push(productId);
    });
    if (!handles.length) {
      document.querySelectorAll('cart-drawer.cart_update .line-item__image-wrapper[href], cart-drawer.cart_update a.product-item-meta__title[href]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (!href) return;
        var match = href.match(/\/products\/([^/?#]+)/);
        if (match && handles.indexOf(match[1]) === -1) handles.push(match[1]);
      });
    }
    return { handles: handles, productIds: productIds };
  }

  function mergeCartPresence(cart) {
    var presence = getCartPresenceFromDrawer();
    if (presence.handles.length) return presence;

    if (!cart || !cart.items) return presence;

    cart.items.forEach(function (item) {
      var handle = getCartLineHandle(item);
      var productId = item.product_id != null ? String(item.product_id) : null;
      if (handle && presence.handles.indexOf(handle) === -1) presence.handles.push(handle);
      if (productId && presence.productIds.indexOf(productId) === -1) presence.productIds.push(productId);
    });
    return presence;
  }

  function ensureFullCart(cartOptional) {
    var hasItems = cartOptional && cartOptional.items && cartOptional.items.length;
    var hasHandles = hasItems && cartOptional.items.some(getCartLineHandle);
    if (hasItems && hasHandles) return Promise.resolve(cartOptional);
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function applyPairWithVisibility(lockedHandles, cartPresence) {
    var root = document.querySelector('[data-cart-update-pair-with]');
    if (!root) return;

    var track = root.querySelector('[data-pair-with-track]');
    lockedHandles.forEach(function (handle) {
      if (!track) return;
      var slide = root.querySelector('[data-pair-with-slide][data-product-handle="' + handle + '"]');
      if (slide) track.appendChild(slide);
    });

    var slides = root.querySelectorAll('[data-pair-with-slide]');
    var visibleCount = 0;

    slides.forEach(function (slide) {
      var handle = slide.getAttribute('data-product-handle');
      var productId = slide.getAttribute('data-product-id');
      var show = lockedHandles.indexOf(handle) !== -1
        && slide.getAttribute('data-available') === 'true'
        && !isInCartPresence(handle, productId, cartPresence);

      slide.hidden = !show;
      slide.classList.remove('hiding');
      slide.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    root.hidden = visibleCount === 0;
    root.removeAttribute('data-pair-with-initialized');
    if (!root.hidden) initCartUpdatePairWith();
  }

  function syncCartUpdatePairWith(cartOptional) {
    var cartDrawer = document.querySelector('cart-drawer.cart_update');
    if (!cartDrawer || cartDrawer.classList.contains('is-empty')) {
      clearPairWithSession();
      var emptyRoot = document.querySelector('[data-cart-update-pair-with]');
      if (emptyRoot) emptyRoot.hidden = true;
      return Promise.resolve();
    }

    return ensureFullCart(cartOptional).then(function (cart) {
      var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      if (!count && cart && cart.items && cart.items.length) {
        count = cart.items.length;
      }

      if (count === 0) {
        clearPairWithSession();
        applyPairWithVisibility([], { handles: [], productIds: [] });
        return;
      }

      var resolved = resolvePairWithLocked(cart);
      applyPairWithVisibility(resolved.locked, resolved.presence);
    }).catch(function (err) {
      console.error('[NorseCartUI] Pair With sync failed:', err);
    });
  }

  function initCartUpdatePairWith() {
    document.querySelectorAll('[data-cart-update-pair-with]').forEach(function (root) {
      if (root.getAttribute('data-pair-with-initialized') === 'true') return;
      root.setAttribute('data-pair-with-initialized', 'true');

      var track = root.querySelector('[data-pair-with-track]');
      var prevBtn = root.querySelector('[data-pair-with-prev]');
      var nextBtn = root.querySelector('[data-pair-with-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var getStep = function () {
        var slide = track.querySelector('.cart-update-pair-with__slide:not([hidden])');
        if (!slide) slide = track.querySelector('.cart-update-pair-with__slide');
        if (!slide || slide.offsetParent === null) return 0;
        return slide.offsetWidth + 15;
      };

      var updateNav = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
      };

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      updateNav();
    });
  }

  function addPairWithToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) { console.error('[NorseCartUI] No variant ID on Pair With button'); return; }
    if (isCartDrawerBusy()) return;

    button.disabled = true;
    setCartDrawerBusy(true);
    var textEl = button.querySelector('.cta-button__text');
    var originalText = textEl ? textEl.textContent : button.textContent;
    var setButtonText = function (t) { textEl ? (textEl.textContent = t) : (button.textContent = t); };
    setButtonText('Adding...');

    var pairPayload = {
      id: variantId,
      quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };
    var predictedPlanId = (button.getAttribute('data-cb-plan-id') || '').trim();
    if (predictedPlanId) {
      pairPayload.properties = { _cb_plan_id: predictedPlanId };
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(pairPayload)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data.status) {
        button.disabled = false;
        setButtonText(originalText);
        alert(data.description || data.message || 'Error adding product to cart.');
        return;
      }

      var addedHandle = button.getAttribute('data-product-handle');
      var addedProductId = button.getAttribute('data-product-id');
      if (addedHandle) {
        document.querySelectorAll('[data-pair-with-slide][data-product-handle="' + addedHandle + '"]')
          .forEach(function (slide) { slide.hidden = true; });
      }
      if (addedProductId) {
        document.querySelectorAll('[data-pair-with-slide][data-product-id="' + addedProductId + '"]')
          .forEach(function (slide) { slide.hidden = true; });
      }

      var done = function () { button.disabled = false; setButtonText(originalText); };
      if (renderCartDrawerFromState(data)) {
        done();
      } else {
        return refreshCartDrawer().catch(console.error).finally(done);
      }
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function (err) {
      console.error('[NorseCartUI] Error adding Pair With product:', err);
      button.disabled = false;
      setButtonText(originalText);
    })
    .finally(function () {
      setCartDrawerBusy(false);
    });
  }

  function addEmptyCartRecommendationToCart(button) {
    var variantId    = button.getAttribute('data-variant-id');
    var sellingPlanId = button.getAttribute('data-selling-plan-id');
    if (!variantId) { console.error('[NorseCartUI] No variant ID'); return; }
    if (isCartDrawerBusy()) return;

    button.disabled = true;
    setCartDrawerBusy(true);
    var textEl = button.querySelector('.cta-button__text');
    var originalText = textEl ? textEl.textContent : button.textContent;
    var setButtonText = function (t) { textEl ? (textEl.textContent = t) : (button.textContent = t); };
    setButtonText('Adding...');

    var cartData = { id: variantId, quantity: 1,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname };
    if (sellingPlanId) cartData.selling_plan = sellingPlanId;

    fetch(cartAddUrl(), {
      method: 'POST', headers: jsonHeaders(), body: JSON.stringify(cartData)
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data.status) {
        button.disabled = false; setButtonText(originalText);
        alert(data.description || data.message || 'Error adding product to cart.');
        return;
      }
      var done = function () { button.disabled = false; setButtonText(originalText); };
      if (renderCartDrawerFromState(data)) {
        done();
        return;
      }
      return refreshCartDrawer().catch(console.error).finally(done);
    })
    .catch(function (err) {
      console.error('[NorseCartUI] Error adding to cart:', err);
      button.disabled = false; setButtonText(originalText);
    })
    .finally(function () {
      setCartDrawerBusy(false);
    });
  }

  function initSubscriptionToggles() {
    document.querySelectorAll('.subscription-checkbox').forEach(function (checkbox) {
      var toggleSwitch = checkbox.nextElementSibling && checkbox.nextElementSibling.nextElementSibling;
      var toggleSvg    = toggleSwitch && toggleSwitch.querySelector('.toggle-svg');
      if (!toggleSvg) return;

      var toggleBg   = toggleSvg.querySelector('.toggle-bg');
      var toggleKnob = toggleSvg.querySelector('.toggle-knob');
      if (!toggleBg || !toggleKnob) return;

      var applyState = function (checked) {
        toggleBg.setAttribute('fill', checked ? '#05AC2E' : '#ccc');
        toggleKnob.setAttribute('transform', checked ? 'translate(0 0)' : 'translate(-8 0)');
      };

      applyState(checkbox.checked);

      // Bind once per node. Re-rendering the drawer produces fresh nodes without
      // the flag, so they get bound; already-bound nodes are skipped. Replacing
      // the node here instead would re-trigger observeCartDrawer('.subscription-checkbox')
      // and loop forever.
      if (checkbox.dataset.hasListener === 'true') return;
      checkbox.dataset.hasListener = 'true';

      checkbox.addEventListener('change', function () {
        if (isCartDrawerBusy()) {
          this.checked = !this.checked;
          return;
        }

        var line          = parseInt(this.dataset.line);
        var variantId     = this.dataset.productId;
        var sellingPlanId = this.dataset.sellingPlanId;
        var isChecked     = this.checked;

        if (!line || !variantId || !sellingPlanId) {
          console.error('[NorseCartUI] Missing data attrs for subscription toggle');
          this.checked = !isChecked;
          return;
        }

        var qtyInput = document.querySelector('input[name="updates[]"][data-line="' + line + '"]');
        var quantity = qtyInput ? parseInt(qtyInput.value) : 1;
        this.disabled = true;
        setCartDrawerBusy(true);

        fetch(cartChangeUrl(), {
          method: 'POST', headers: jsonHeaders(),
          body: JSON.stringify({
            line: line, quantity: quantity,
            selling_plan: isChecked ? sellingPlanId : null,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          applyState(isChecked);
          if (renderCartDrawerFromState(data)) {
            checkbox.disabled = false;
            return;
          }
          return refreshCartDrawer().catch(console.error).finally(function () {
            checkbox.disabled = false;
          });
        })
        .catch(function (err) {
          console.error('[NorseCartUI] Error updating subscription:', err);
          checkbox.checked = !isChecked;
          checkbox.disabled = false;
          alert('There was an error updating your subscription. Please try again.');
        })
        .finally(function () {
          setCartDrawerBusy(false);
        });
      });
    });
  }

  function initSubscriptionButtons() {
    document.querySelectorAll('.cart-item__subscription-upgrade-btn').forEach(function (button) {
      // See initSubscriptionToggles: replacing the node re-triggers
      // observeCartDrawer('.cart-item__subscription-upgrade-btn') in a loop.
      if (button.dataset.hasListener === 'true') return;
      button.dataset.hasListener = 'true';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (isCartDrawerBusy()) return;

        var line          = parseInt(this.dataset.line);
        var variantId     = this.dataset.variantId;
        var sellingPlanId = this.dataset.sellingPlanId;

        if (!line || !variantId || !sellingPlanId) {
          console.error('[NorseCartUI] Missing data attrs for subscription upgrade');
          return;
        }

        var qtyInput = document.querySelector('#Drawer-quantity-' + line);
        var quantity = qtyInput ? parseInt(qtyInput.value) : 1;
        this.disabled = true;
        var originalText = this.textContent;
        this.textContent = 'Updating...';
        var btn = this;
        setCartDrawerBusy(true);

        fetch(cartChangeUrl(), {
          method: 'POST', headers: jsonHeaders(),
          body: JSON.stringify({
            line: line, quantity: quantity, selling_plan: sellingPlanId,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var done = function () { btn.disabled = false; btn.textContent = originalText; };
          if (renderCartDrawerFromState(data)) { done(); return; }
          refreshCartDrawer().catch(console.error).finally(done);
        })
        .catch(function (err) {
          console.error('[NorseCartUI] Error updating subscription:', err);
          btn.disabled = false; btn.textContent = originalText;
          alert('There was an error updating your subscription. Please try again.');
        })
        .finally(function () {
          setCartDrawerBusy(false);
        });
      });
    });
  }

  function initQuantitySelectors() {
    document.querySelectorAll('.custom-quantity-selector__button').forEach(function (button) {
      if (button.dataset.hasListener === 'true') return;
      button.dataset.hasListener = 'true';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isCartDrawerBusy()) return;

        var href = this.getAttribute('href');
        if (!href) return;

        var isRemove = this.classList.contains('custom-quantity-selector__button--remove') ||
          (href.indexOf('change') !== -1 && href.indexOf('quantity=0') !== -1);

        var qtyInput = this.closest('.custom-quantity-selector') &&
          this.closest('.custom-quantity-selector').querySelector('input[name="updates[]"]');
        var lineFromInput = qtyInput ? qtyInput.dataset.line : null;

        if (isRemove && lineFromInput) {
          var cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
            cartDrawerItems.updateQuantity(parseInt(lineFromInput), 0,
              { currentTarget: this, preventDefault: function () {}, stopPropagation: function () {} });
            return;
          }

          setRemoveControlLoading(this, true);
          setCartDrawerBusy(true);
          var self = this;
          fetch(cartChangeUrl(), {
            method: 'POST', headers: jsonHeaders(),
            body: JSON.stringify({
              line: parseInt(lineFromInput), quantity: 0,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (renderCartDrawerFromState(data)) return;
            refreshCartDrawer().catch(console.error);
          })
          .catch(function (err) { console.error('[NorseCartUI] Error removing item:', err); })
          .finally(function () {
            setRemoveControlLoading(self, false);
            setCartDrawerBusy(false);
          });
          return;
        }

        var url      = new URL(href, window.location.origin);
        var line     = url.searchParams.get('line');
        var quantity = url.searchParams.get('quantity');
        if (!line || !quantity) return;

        var cartItems = document.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.updateQuantity === 'function') {
          cartItems.updateQuantity(parseInt(line), parseInt(quantity),
            { currentTarget: this, preventDefault: function () {}, stopPropagation: function () {} });
          return;
        }

        setCartDrawerBusy(true);
        fetch(cartChangeUrl(), {
          method: 'POST', headers: jsonHeaders(),
          body: JSON.stringify({
            line: parseInt(line), quantity: parseInt(quantity),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (renderCartDrawerFromState(data)) return;
          refreshCartDrawer().catch(console.error);
        })
        .catch(function (err) { console.error('[NorseCartUI] Error updating quantity:', err); })
        .finally(function () {
          setCartDrawerBusy(false);
        });
      });
    });
  }

  function initAll() {
    initSubscriptionToggles();
    initSubscriptionButtons();
    initQuantitySelectors();
    syncCartUpdatePairWith().catch(console.error);
    scheduleProgressBarSync();
  }

  onReady(initAll);
  observeCartDrawer('.subscription-checkbox',                 initSubscriptionToggles);
  observeCartDrawer('.cart-item__subscription-upgrade-btn',   initSubscriptionButtons);
  observeCartDrawer('.custom-quantity-selector',              initQuantitySelectors);
  observeCartDrawer('.cart-update-shipping-zone',             scheduleProgressBarSync);
  observeCartDrawer('[data-cart-update-pair-with]', function () {
    schedulePairWithSync(null, 120);
  });

  function onCartDrawerChanged(cartData, delay) {
    if (cartData && typeof cartData.item_count === 'number') {
      updateCartUpdateHeaderCount(cartData.item_count);
    }
    setTimeout(function () {
      initQuantitySelectors();
      initSubscriptionToggles();
      schedulePairWithSync(cartData, 80);
    }, delay);
  }

  document.addEventListener('cart:update', function () {
    onCartDrawerChanged(null, 100);
  });

  if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var source = event && event.source;
      if (source === 'nbbb-update' || source === 'nbbb-sub') {
        onCartDrawerChanged(event && event.cartData, 80);
        return;
      }
      var delay = source === 'cart-items' ? 50 : 350;
      onCartDrawerChanged(event && event.cartData, delay);
    });
  }

  window.NorseCartUI = Object.assign(window.NorseCartUI || {}, {
    updateCartUpdateHeaderCount:          updateCartUpdateHeaderCount,
    setCartDrawerBusy:                    setCartDrawerBusy,
    isCartDrawerBusy:                     isCartDrawerBusy,
    setRemoveControlLoading:              setRemoveControlLoading,
    renderCartDrawerFromState:            renderCartDrawerFromState,
    refreshCartDrawer:                    refreshCartDrawer,
    syncProgressBarPresentment:           syncProgressBarPresentment,
    scheduleProgressBarSync:              scheduleProgressBarSync,
    formatPresentmentMoney:               formatPresentmentMoney,
    getPresentmentThresholdCents:         getPresentmentThresholdCents,
    resolvePresentmentRate:               resolvePresentmentRate,
    cacheCartCurrency:                    cacheCartCurrency,
    updateCTATotal:                       updateCTATotal,
    addRecommendationToCart:              addRecommendationToCart,
    addEmptyCartRecommendationToCart:     addEmptyCartRecommendationToCart,
    initSubscriptionToggles:              initSubscriptionToggles,
    initSubscriptionButtons:              initSubscriptionButtons,
    initQuantitySelectors:                initQuantitySelectors,
    initCartUpdatePairWith:               initCartUpdatePairWith,
    syncCartUpdatePairWith:               syncCartUpdatePairWith,
    schedulePairWithSync:                 schedulePairWithSync,
    addPairWithToCart:                    addPairWithToCart,
  });

  window.addRecommendationToCart             = addRecommendationToCart;
  window.addEmptyCartRecommendationToCart    = addEmptyCartRecommendationToCart;
  window.addPairWithToCart                   = addPairWithToCart;
})();
